export const queueDefinition: any = {
  'my-cases': {
    name: 'my-cases',
    queueType: 'assignee',
    queueFilter: '?status=!completed&status=!archived',
    queueSort: 'sort=createdAt&dir=1',
    limit: 30,
    pollingEnabled: false
  },
  'document-control-completed-unread-chat': {
    name: 'document-control-completed-unread-chat',
    queueFilter: '?flowDefinitionId=document-control-se&status=completed',
    queueSort: 'sort=createdAt&dir=-1',
    queueType: 'chat',
    limit: 30,
    pollingEnabled: false
  },
  Incoming: {
    name: 'Incoming',
    queueFilter:
      '?view=queueView&status=!completed&status=!archived&flowDefinitionId=document-control-se&data.externalRequiredDocumentsOk=false',
    queueSort: 'sort=createdAt&dir=-1',
    limit: 30,
    limitIncrease: 20,
    pollingEnabled: false
  },
  Inbox: {
    name: 'Inbox',
    queueFilter:
      '?view=queueView&status=!completed&status=!archived&flowDefinitionId=document-control-se&data.externalRequiredDocumentsOk=true&data.allDocumentsAreOk=false&assignee.id=!',
    queueSort: 'sort=data.inboxDate&dir=1',
    limit: 60,
    limitIncrease: 20,
    pollingEnabled: false
  },
  Control: {
    name: 'Control',
    queueFilter:
      '?view=queueView&status=!completed&status=!archived&flowDefinitionId=document-control-se&data.externalRequiredDocumentsOk=true&data.allDocumentsAreOk=false&assignee.id=',
    queueSort: 'sort=data.inboxDate&dir=-1',
    limit: 30,
    limitIncrease: 20,
    pollingEnabled: false
  },
  Audit: {
    name: 'Audit',
    queueFilter:
      '?view=queueView&status=!completed&status=!archived&flowDefinitionId=document-control-se&tasks.taskType=dcse-audit-documents&tasks.status=pending',
    queueSort: 'sort=data.inboxDate&dir=-1',
    limit: 30,
    limitIncrease: 20,
    pollingEnabled: false
  },
  'Select post control': {
    name: 'Select post control',
    queueFilter:
      '?view=queueView&status=!completed&status=!archived&flowDefinitionId=document-control-se&tasks.taskType=dcse-decide-followup-needed&tasks.status=pending',
    queueSort: 'sort=createdAt&dir=1',
    limit: 20,
    pollingEnabled: false
  },
  'Post control': {
    name: 'Post control',
    queueFilter:
      '?view=queueView&status=!completed&status=!archived&flowDefinitionId=document-control-se&tasks.taskType=dcse-follow-up&tasks.status=pending',
    queueSort: 'sort=createdAt&dir=1',
    limit: 20,
    pollingEnabled: false
  },
  Archiving: {
    name: 'Archiving',
    queueFilter:
      '?view=queueView&status=!completed&status=!archived&flowDefinitionId=document-control-se&data.storedFiles=',
    queueSort: 'sort=updatedAt&dir=1',
    limit: 20,
    limitIncrease: 20,
    pollingEnabled: false
  },
  Failed: {
    name: 'Failed',
    queueFilter:
      '?view=queueView&flowDefinitionId=document-control-se&status=active&hasErrors=true',
    queueSort: 'sort=createdAt&dir=-1',
    pollingEnabled: false
  },
  'document-control-unread-chat': {
    name: 'document-control-unread-chat',
    queueFilter:
      '?view=queueView&flowDefinitionId=document-control-se&status=active',
    queueSort: 'sort=createdAt&dir=-1',
    queueType: 'chat',
    limit: 30,
    pollingEnabled: false
  },
  'register-se-hp': {
    name: 'register-se-hp',
    queueFilter:
      '?view=queueView&status=!archived&flowDefinitionId=document-control-se&data.product.ncvsId=545&sort=createdAt&dir=-1',
    queueType: 'task',
    taskFilter:
      '/?taskType=dcse-contract-and-car-registry-check&status=pending&sort=createdAt&dir=-1',
    limit: 30,
    limitIncrease: 20,
    pollingEnabled: false
  },
  'perform-payout-se-hp': {
    name: 'perform-payout-se-hp',
    queueFilter:
      '?view=queueView&status=!archived&flowDefinitionId=document-control-se&data.product.ncvsId=545&assignee.id=!&tasks.taskType=dcse-perform-payout-and-start-contract&tasks.status=pending',
    queueSort: 'sort=createdAt&dir=-1',
    pollingEnabled: false
  },
  'picked-perform-payout-se-hp': {
    name: 'picked-perform-payout-se-hp',
    queueFilter:
      '?view=queueView&status=!archived&status=!completed&flowDefinitionId=document-control-se&data.product.ncvsId=545&tasks.taskType=dcse-perform-payout-and-start-contract&tasks.status=pending',
    queueSort: 'sort=createdAt&dir=-1',
    queueType: 'assignee',
    pollingEnabled: false
  },
  'register-se-le': {
    name: 'register-se-le',
    queueFilter:
      '?view=queueView&status=!archived&flowDefinitionId=document-control-se&data.product.ncvsId=!545&tasks.taskType=dcse-contract-and-car-registry-check&tasks.status=pending',
    queueSort: 'sort=createdAt&dir=-1',
    limit: 10,
    limitIncrease: 10,
    pollingEnabled: false
  },
  'perform-payout-se-le': {
    name: 'perform-payout-se-le',
    queueFilter:
      '?view=queueView&status=!archived&flowDefinitionId=document-control-se&data.product.ncvsId=!545&assignee.id=!&tasks.taskType=dcse-perform-payout-and-start-contract&tasks.status=pending',
    queueSort: 'sort=createdAt&dir=-1',
    pollingEnabled: false
  },
  'picked-perform-payout-se-le': {
    name: 'picked-perform-payout-se-le',
    queueFilter:
      '?view=queueView&status=!archived&status=!completed&flowDefinitionId=document-control-se&data.product.ncvsId=!545&tasks.taskType=dcse-perform-payout-and-start-contract&tasks.status=pending',
    queueSort: 'sort=createdAt&dir=-1',
    queueType: 'assignee',
    pollingEnabled: false
  },
  'Credit Inbox': {
    name: 'Credit Inbox',
    queueFilter:
      '?view=queueView&status=!completed&status=!archived&status=!initiating&flowDefinitionId=credit-check&assignee.id=!&data.caseDetails.contractStatus=!Approved',
    queueSort: 'sort=createdAt&dir=-1',
    limit: 30,
    limitIncrease: 20,
    pollingEnabled: false
  },
  Ongoing: {
    name: 'Ongoing',
    queueFilter:
      '?view=queueView&status=!completed&status=!archived&flowDefinitionId=credit-check&assignee.id=&data.caseDetails.contractStatus=!Approved',
    queueSort: 'sort=createdAt&dir=-1',
    limit: 30,
    limitIncrease: 20,
    pollingEnabled: false
  },
  Approved: {
    name: 'Approved',
    queueFilter:
      '?view=queueView&status=!completed&status=!archived&flowDefinitionId=credit-check&data.caseDetails.contractStatus=Approved',
    queueSort: 'sort=createdAt&dir=-1',
    limit: 30,
    pollingEnabled: false
  },
  'Failed credit': {
    name: 'Failed credit',
    queueFilter:
      '?view=queueView&status=!archived&flowDefinitionId=credit-check&hasErrors=true',
    queueSort: 'sort=createdAt&dir=-1',
    pollingEnabled: false
  },
  'credit-unread-chat': {
    name: 'credit-unread-chat',
    queueFilter: '?view=queueView&flowDefinitionId=credit-check&status=active',
    queueSort: 'sort=createdAt&dir=-1',
    queueType: 'chat',
    pollingEnabled: false,
    limit: 30
  },
  'credit-not-approved-uploads': {
    name: 'credit-not-approved-uploads',
    queueFilter:
      '?flowDefinitionId=credit-check&status=active&tasks.taskType=cc-approve-document&tasks.status=pending',
    queueSort: 'sort=createdAt&dir=-1',
    pollingEnabled: false
  },
  'cd-assessment-queue-car': {
    name: 'cd-assessment-queue-car',
    queueFilter:
      '?view=queueView&status=!completed&status=!archived&flowDefinitionId[]=customer-declaration-private-se&flowDefinitionId[]=customer-declaration-private-new-se&data.businessStatus=assessment&data.concept=car&assignee.id=!',
    queueSort: 'sort=createdAt&dir=-1',
    limit: 10,
    pollingEnabled: false
  },
  'cd-assessment-assigned-queue-car': {
    name: 'cd-assessment-assigned-queue-car',
    queueFilter:
      '?view=queueView&status=!completed&status=!archived&flowDefinitionId[]=customer-declaration-private-se&flowDefinitionId[]=customer-declaration-private-new-se&data.businessStatus=assessment&data.concept=car&assignee.id=',
    queueSort: 'sort=createdAt&dir=-1',
    limit: 10,
    pollingEnabled: false
  },
  'kyc-failed-car': {
    name: 'kyc-failed-car',
    queueFilter:
      '?view=queueView&status=!archived&flowDefinitionId[]=customer-declaration-private-se&flowDefinitionId[]=customer-declaration-private-new-se&data.concept=car&hasErrors=true',
    queueSort: 'sort=createdAt&dir=-1',
    pollingEnabled: false
  },
  'cd-assessment-queue-corporate': {
    name: 'cd-assessment-queue-corporate',
    queueFilter:
      '?view=queueView&status=!completed&status=!archived&flowDefinitionId=customer-declaration-business-new-se&data.businessStatus=assessment&data.concept=car&assignee.id=!',
    queueSort: 'sort=createdAt&dir=-1',
    limit: 30,
    pollingEnabled: false
  },
  'cd-assessment-assigned-queue-corporate': {
    name: 'cd-assessment-assigned-queue-corporate',
    queueFilter:
      '?view=queueView&status=!completed&status=!archived&flowDefinitionId=customer-declaration-business-new-se&data.businessStatus=assessment&data.concept=car&assignee.id=',
    queueSort: 'sort=createdAt&dir=-1',
    limit: 30,
    pollingEnabled: false
  },
  'kyc-failed-corporate': {
    name: 'kyc-failed-corporate',
    queueFilter:
      '?view=queueView&status=!archived&flowDefinitionId=customer-declaration-business-new-se&data.concept=car&hasErrors=true',
    queueSort: 'sort=createdAt&dir=-1',
    pollingEnabled: false
  },
  'cd-assessment-queue-equipment': {
    name: 'cd-assessment-queue-equipment',
    queueFilter:
      '?view=queueView&status=!completed&status=!archived&flowDefinitionId=customer-declaration-business-new-se&data.businessStatus=assessment&data.concept=vendor&assignee.id=!',
    queueSort: 'sort=createdAt&dir=-1',
    limit: 10
  },
  'cd-assessment-assigned-queue-equipment': {
    name: 'cd-assessment-assigned-queue-equipment',
    queueFilter:
      '?view=queueView&status=!completed&status=!archived&flowDefinitionId=customer-declaration-business-new-se&data.businessStatus=assessment&data.concept=vendor&assignee.id=',
    queueSort: 'sort=createdAt&dir=-1',
    limit: 10
  },
  'kyc-failed-equipment': {
    name: 'kyc-failed-equipment',
    queueFilter:
      '?view=queueView&status=!archived&flowDefinitionId=customer-declaration-business-new-se&data.concept=vendor&hasErrors=true',
    queueSort: 'sort=createdAt&dir=-1',
    pollingEnabled: false
  }
}
